import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Box,
  styled,
  Typography
} from "@mui/material";

import {
  getVendorEWFSetting
} from "../../../../../actions/employee-welfare-fund";

const Root = styled("div")({
  marginTop: "30px",
  "& .MuiTypography-h6": {
    fontSize: "1.5rem",
  },
});

const EmployeeWelfareFund = () => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const { result: vendorEWFSetting } = useSelector(state => state.vendorEmployeeWelfareFund);

  useEffect(() => {
    dispatch(getVendorEWFSetting());
  },[]);

  return (
    <Root>
      <Typography variant="h6">{t("employeeWelfareFund")}</Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: "16px"
        }}
      >
        <Typography>{t("employeeWelfareFundStandard")}</Typography>
        <Typography style={{ fontWeight: 500 }}>{
          (vendorEWFSetting && vendorEWFSetting.isDefault === 1) 
            ? (vendorEWFSetting.isOnlyNoPF === 1)
              ? t("everyoneExceptProvidentFund")
              : t("everyone")
            : t("noEmployees")
        }</Typography>
      </Box>
    </Root>
  );
};

export default EmployeeWelfareFund;